// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import moment from "moment";

export const loadMomentLocale = (locale) => {
  if (locale === "ja") {
    import("moment/locale/ja");
    moment.locale("ja"); // 'ja'
  } else {
    // Currently: HK still use EN locale
    // => So we not set default to zn-CN
    moment.locale("en");
  }
};
